<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    Ukryj widget.
    <div class="HintsTemplate__description">
      Widget nie będzie widoczny na wszystkich stronach.
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvisibleAfterHoursBehavior',
};
</script>
